import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * iter169 — Floating "Back to Route" affordance. Shows on any deep
 * admin page (customer bookings, job detail, etc.) so the crew can
 * always return to today's Route with one tap. Hidden on the /admin
 * shell itself and on non-admin pages.
 *
 * Renders a fixed bottom-right pill so it never fights with existing
 * page CTAs and is thumb-reachable on mobile.
 */
export default function BackToRouteFab() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Only show when we're on an admin sub-page — NOT on the main admin
  // shell (which already renders the Route tab).
  const isAdminSubpage =
    pathname.startsWith("/admin/") && pathname !== "/admin";
  if (!isAdminSubpage) return null;
  return (
    <button
      type="button"
      onClick={() => navigate("/admin?tab=route")}
      data-testid="back-to-route-fab"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-4 py-3 rounded-full bg-[#047857] text-white shadow-2xl text-sm font-extrabold tracking-tight hover:bg-[#065F46] active:scale-95 transition"
      aria-label="Back to today's route"
    >
      <ArrowLeft className="w-4 h-4" />
      Back to Route
    </button>
  );
}
